import { ThankYouCardApiClient } from '@fourthwall/services/dist/ThankYouCardApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useThankYouCardUploadMutation = createMutationHook(
  ThankYouCardApiClient.getUploadUrl,
  {
    mutationKey: ['thankYouCardUpload'],
  },
)
